import React from 'react'

export default class Dropdown extends React.Component {
    constructor(props) {
        super(props)

        this.valueNames = Object.keys(this.props.values)

        this.state = {
            current: this.props.default || this.valueNames[0],
        }

        this.listDisplay = 'none'

        this.defaultStyle = {
            selection: {
                position: "relative",
                cursor: "pointer",
                outline: "none",
                userSelect: "none",
                whiteSpace: "nowrap"
            },
            icon: {
                display: "inline-block",
                verticalAlign: "middle",
                content: "",
                border: "4px solid",
                borderRightColor: "transparent",
                borderBottomColor: "transparent",
                borderLeftColor: "transparent",
                position: "absolute",
                right: 0,
                top: "5px"
            },
            list: {
                display: "none",
                // width: "100%",
                position: "absolute",
                whiteSpace: "nowrap"
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        // this.props = nextProps
        this.setState({
            current: nextProps.default
        })
    }

    componentDidUpdate() {
        this.valueNames = Object.keys(this.props.values)
    }

    toggleList = () => {
        if ('none'===this.listDisplay) {
            this.list.style.display = (this.listDisplay = 'block')
        } else {
            this.list.style.display = (this.listDisplay = 'none')
        }
    }

    selectionChanged = (valueName) => {
        this.setState({current: valueName})

        if (this.props.onChange) {
            this.props.onChange(valueName)
        }
    }

    render() {
        return (
            <span
                className={"dropdown "+(this.props.className?this.props.className:'')}
                style={this.props.nostyle?{}:this.defaultStyle.selection}
                onClick={()=>{this.toggleList()}}
                tabIndex="-1"
                onBlur={()=>{
                    this.list.style.display = (this.listDisplay = 'none')
                }}
            >
                <span className="dropdown-text">{this.props.values[this.state.current]}</span>
                <span className="dropdown-icon" style={this.defaultStyle.icon}></span>
                <span className="dropdown-list" ref={c=>this.list=c} style={this.defaultStyle.list}>
                    {
                        this.valueNames.map(
                            (valueName, index) => (
                                <span
                                    key={index}
                                    className={"dropdown-list-item" + (valueName===this.state.current?' selected':'')}
                                    onClick={()=>{this.selectionChanged(valueName)}}
                                >{this.props.values[valueName]}</span>
                            )
                        )
                    }
                </span>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Dropdown.js